export const categories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'romance', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻', icon: 'ri-magic-line' },
  { slug: 'action', name: '动作', icon: 'ri-flashlight-line' },
  { slug: 'mystery', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'comedy', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'drama', name: '剧情', icon: 'ri-film-line' },
  { slug: 'historical', name: '古风', icon: 'ri-ancient-gate-line' },
  { slug: 'urban', name: '都市', icon: 'ri-building-line' },
];

export const comics = [
  {
    id: 1,
    title: '秘密恋爱手册',
    author: '金秀雅',
    category: 'romance',
    status: '连载中',
    rating: 4.8,
    views: 1250000,
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20illustration%20featuring%20a%20young%20couple%20in%20soft%20pastel%20colors%2C%20cherry%20blossoms%20in%20background%2C%20clean%20minimalist%20style%2C%20webtoon%20art%2C%20gentle%20warm%20lighting%2C%20simple%20elegant%20composition%20on%20light%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '大学校园里的青涩恋爱故事。女主角林小雨在图书馆偶然遇见了校草韩志浩，从此开启了一段甜蜜又纠结的校园恋情。面对友情与爱情的抉择，她将如何选择？',
    tags: ['校园', '甜宠', '青春'],
    chapters: [
      { id: 1, title: '第1话 意外的相遇', updateDate: '2026-08-01' },
      { id: 2, title: '第2话 图书馆的秘密', updateDate: '2026-08-02' },
      { id: 3, title: '第3话 心跳加速', updateDate: '2026-08-03' },
      { id: 4, title: '第4话 误会', updateDate: '2026-08-04' },
    ],
  },
  {
    id: 2,
    title: '剑与魔法之巅',
    author: '李东旭',
    category: 'fantasy',
    status: '连载中',
    rating: 4.9,
    views: 2300000,
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20illustration%20with%20a%20hero%20holding%20a%20glowing%20sword%20in%20a%20magical%20world%2C%20mystical%20blue%20and%20gold%20color%20palette%2C%20clean%20webtoon%20art%20style%2C%20simple%20light%20background%2C%20dramatic%20but%20clean%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个被魔法统治的世界里，普通少年金泰亨意外获得了传说中的神剑，从此踏上成为最强魔法剑士的冒险之旅。他将面对强大的敌人，揭开世界的秘密。',
    tags: ['冒险', '热血', '魔法'],
    chapters: [
      { id: 1, title: '第1话 觉醒之日', updateDate: '2026-07-28' },
      { id: 2, title: '第2话 初战', updateDate: '2026-07-29' },
      { id: 3, title: '第3话 新的伙伴', updateDate: '2026-07-30' },
      { id: 4, title: '第4话 试炼之塔', updateDate: '2026-08-01' },
      { id: 5, title: '第5话 黑暗来袭', updateDate: '2026-08-03' },
    ],
  },
  {
    id: 3,
    title: '暗夜追踪者',
    author: '朴振英',
    category: 'action',
    status: '已完结',
    rating: 4.7,
    views: 1890000,
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20manhwa%20cover%20illustration%20with%20a%20mysterious%20detective%20in%20trench%20coat%20against%20city%20night%20skyline%2C%20noir%20atmosphere%2C%20clean%20webtoon%20style%2C%20simple%20dark%20background%2C%20dramatic%20lighting%20with%20neon%20accents&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '首尔夜晚的街头，一名神秘侦探追踪连环案件。他被卷入了一场涉及政商两界的巨大阴谋。真相究竟隐藏在哪里？一部紧张刺激的都市动作悬疑漫画。',
    tags: ['悬疑', '都市', '硬汉'],
    chapters: [
      { id: 1, title: '第1话 夜幕降临', updateDate: '2026-06-15' },
      { id: 2, title: '第2话 第一个线索', updateDate: '2026-06-22' },
      { id: 3, title: '第3话 追踪', updateDate: '2026-06-29' },
    ],
  },
  {
    id: 4,
    title: '微笑的假面',
    author: '崔美英',
    category: 'mystery',
    status: '连载中',
    rating: 4.6,
    views: 980000,
    cover: 'https://readdy.ai/api/search-image?query=A%20mystery%20thriller%20Korean%20manhwa%20cover%20with%20a%20masked%20figure%20and%20puzzle%20pieces%2C%20intriguing%20atmosphere%2C%20clean%20webtoon%20art%2C%20muted%20warm%20tones%2C%20simple%20background%2C%20elegant%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '一所贵族高中发生了一系列离奇事件。学生会会长朴智雅展开调查，却发现每个人脸上都戴着微笑的假面。真相令人不寒而栗......',
    tags: ['校园', '推理', '惊悚'],
    chapters: [
      { id: 1, title: '第1话 新学期', updateDate: '2026-07-20' },
      { id: 2, title: '第2话 消失的同学', updateDate: '2026-07-25' },
      { id: 3, title: '第3话 怀疑', updateDate: '2026-08-01' },
    ],
  },
  {
    id: 5,
    title: '爆笑便利店',
    author: '刘在石',
    category: 'comedy',
    status: '连载中',
    rating: 4.5,
    views: 1560000,
    cover: 'https://readdy.ai/api/search-image?query=A%20funny%20comedy%20Korean%20manhwa%20cover%20with%20colorful%20convenience%20store%20setting%20and%20quirky%20characters%2C%20bright%20cheerful%20colors%2C%20clean%20webtoon%20style%2C%20simple%20light%20background%2C%20playful%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '一家24小时便利店里，聚集了一群奇葩顾客和搞笑店员。每天都有令人捧腹的故事发生。无厘头的日常喜剧，笑到停不下来！',
    tags: ['日常', '搞笑', '轻松'],
    chapters: [
      { id: 1, title: '第1话 新来的兼职生', updateDate: '2026-08-01' },
      { id: 2, title: '第2话 深夜客人', updateDate: '2026-08-02' },
    ],
  },
  {
    id: 6,
    title: '王朝之光',
    author: '韩素希',
    category: 'historical',
    status: '已完结',
    rating: 4.9,
    views: 3100000,
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20Korean%20manhwa%20cover%20with%20traditional%20hanbok%20clothing%20and%20ancient%20palace%20setting%2C%20elegant%20warm%20golden%20tones%2C%20clean%20webtoon%20style%2C%20simple%20parchment%20background%2C%20refined%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '朝鲜王朝时期，一位天才少女伪装成男子进入宫中成为史官。她在权力的漩涡中周旋，用智慧与勇气改变了历史的轨迹。',
    tags: ['历史', '宫廷', '权谋'],
    chapters: [
      { id: 1, title: '第1话 入宫', updateDate: '2026-05-01' },
      { id: 2, title: '第2话 初露锋芒', updateDate: '2026-05-08' },
      { id: 3, title: '第3话 危机四伏', updateDate: '2026-05-15' },
      { id: 4, title: '第4话 大结局', updateDate: '2026-05-22' },
    ],
  },
  {
    id: 7,
    title: '都市夜语',
    author: '郑有美',
    category: 'urban',
    status: '连载中',
    rating: 4.4,
    views: 870000,
    cover: 'https://readdy.ai/api/search-image?query=A%20modern%20urban%20Korean%20manhwa%20cover%20with%20city%20nightlife%20scene%20and%20stylish%20characters%2C%20moody%20warm%20lighting%2C%20clean%20webtoon%20art%20style%2C%20simple%20background%2C%20sophisticated%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '在繁华的首尔都市中，五个年轻人的生活交织在一起。他们追逐梦想、面对现实、寻找真爱。一部真实又温暖的都市生活群像剧。',
    tags: ['都市', '群像', '写实'],
    chapters: [
      { id: 1, title: '第1话 凌晨两点的首尔', updateDate: '2026-07-30' },
      { id: 2, title: '第2话 咖啡与梦想', updateDate: '2026-08-02' },
    ],
  },
  {
    id: 8,
    title: '命运的重量',
    author: '张贤胜',
    category: 'drama',
    status: '连载中',
    rating: 4.7,
    views: 1450000,
    cover: 'https://readdy.ai/api/search-image?query=A%20emotional%20drama%20Korean%20manhwa%20cover%20with%20two%20characters%20facing%20each%20other%20in%20rain%2C%20melancholic%20atmosphere%2C%20clean%20webtoon%20style%2C%20simple%20muted%20background%2C%20poetic%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '一场车祸改变了所有人的命运。失去记忆的男人与等待他的女人，命运的齿轮再次转动。一部关于爱与救赎的深刻剧情漫画。',
    tags: ['爱情', '悲剧', '治愈'],
    chapters: [
      { id: 1, title: '第1话 雨天的约定', updateDate: '2026-07-15' },
      { id: 2, title: '第2话 空白', updateDate: '2026-07-22' },
      { id: 3, title: '第3话 重逢', updateDate: '2026-07-29' },
    ],
  },
];

export const testimonials = [
  {
    id: 1,
    name: '小王',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20user%20avatar%20portrait%20in%20soft%20warm%20colors%2C%20clean%20background%2C%20friendly%20expression%2C%20simple%20illustration%20style&width=100&height=100&seq=avatar-01&orientation=squarish',
    comment: '韩漫屋真的是我找到的最全的韩漫网站了！资源更新速度超快，而且全部免费无删减，画质也很清晰。每天都在这里追更新，太爱了！',
    date: '2026-07-28',
  },
  {
    id: 2,
    name: '小李',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20user%20avatar%20portrait%20in%20soft%20warm%20colors%2C%20clean%20background%2C%20gentle%20expression%2C%20minimal%20illustration%20style&width=100&height=100&seq=avatar-02&orientation=squarish',
    comment: '分类做得很好，找漫画特别方便。而且每部漫画的简介和标签都很清晰，能快速找到自己喜欢的类型。强烈推荐给所有韩漫爱好者！',
    date: '2026-07-25',
  },
  {
    id: 3,
    name: '小张',
    avatar: 'https://readdy.ai/api/search-image?query=A%20simple%20minimalist%20user%20avatar%20portrait%20in%20soft%20warm%20colors%2C%20clean%20background%2C%20cheerful%20expression%2C%20minimal%20illustration%20style&width=100&height=100&seq=avatar-03&orientation=squarish',
    comment: '用了很多漫画网站，韩漫屋的体验是最好的。页面干净没有乱七八糟的广告，加载速度也很快。收藏功能如果能加上就更完美了！',
    date: '2026-07-20',
  },
];

export const faqs = [
  {
    question: '韩漫屋上的漫画都是免费的吗？',
    answer: '是的！韩漫屋上所有韩国漫画资源均提供完全免费的在线阅读服务，无需注册、无需付费，随时随地畅享韩漫阅读体验。',
  },
  {
    question: '漫画资源是否完整无删减？',
    answer: '我们承诺所有漫画资源均为完整版本，不含任何删减内容。我们致力于为读者提供最原汁原味的韩国漫画阅读体验。',
  },
  {
    question: '漫画更新频率如何？',
    answer: '我们团队每天都在跟踪最新韩漫更新动态，确保第一时间同步最新章节。热门漫画通常能在更新当天内完成同步。',
  },
  {
    question: '需要注册账号才能阅读吗？',
    answer: '不需要！韩漫屋目前无需注册即可畅读所有漫画。我们相信简单的用户体验才是最好的。',
  },
  {
    question: '移动端能否正常阅读？',
    answer: '韩漫屋网站全面适配移动端设备，在手机和平板上都可以获得流畅舒适的阅读体验。',
  },
];